import { render, staticRenderFns } from "./discrepancy.vue?vue&type=template&id=1c90a1c2"
import script from "./discrepancy.vue?vue&type=script&lang=js"
export * from "./discrepancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports